import { makeRootStyles } from "../../theme/styles";

const useStyles = makeRootStyles(
  {
    shopNowWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
  },
  { name: "ReturnReasonsExchange" },
);

export { useStyles };
